import { render, staticRenderFns } from "./roomType.vue?vue&type=template&id=c0f0c6d2&scoped=true"
import script from "./roomType.vue?vue&type=script&lang=js"
export * from "./roomType.vue?vue&type=script&lang=js"
import style0 from "./roomType.vue?vue&type=style&index=0&id=c0f0c6d2&prod&lang=scss&scoped=true"
import style1 from "./roomType.vue?vue&type=style&index=1&id=c0f0c6d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f0c6d2",
  null
  
)

export default component.exports